const toggles = document.querySelectorAll('.site-nav__menu-link');

toggles.forEach(button => {
  button.addEventListener('click', function (e) {
    const menuItem = button.closest('.site-nav__menu-item');

    const submenu = menuItem.querySelector('.site-nav__submenu');
    if (!submenu) {
      return;
    }

    e.preventDefault();

    const allItems = document.querySelectorAll('.site-nav__menu-item');
    allItems.forEach(item => {
      if (item !== menuItem) {
        item.classList.remove('is-open');
      }
    });

    menuItem.classList.toggle('is-open');
  });
});
